import React, { Component, useEffect, useRef, useState } from "react";
import CryptoJS from "crypto-js";
import styled, { keyframes } from "styled-components";

class Temp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "ENCRYPT",
      inputText: "",
      encryptedText: "",
    };
    this.handleInputChanged = this.handleInputChanged.bind(this);
    this.encryptText = this.encryptText.bind(this);

    this.TEST_MODE = ["ENCRYPT", "DONUT"];
    this.TEST_COMPONENT = { ENCRYPT: null, DONUT: <DonutTest /> };
  }

  handleInputChanged(event) {
    this.setState({
      ...this.state,
      inputText: event.target.value,
    });
  }

  encryptText() {
    const text = this.state.inputText;
    const p = "testkey";
    var iv = CryptoJS.lib.WordArray.create([0, 0, 0, 0]);
    const key = CryptoJS.enc.Utf8.parse(p);
    for (var i = key.words.length; i < 4; i++) {
      key.words[i] = 0;
    }
    key.sigBytes = 16;
    key.clamp();

    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    console.log(encrypted);
    this.setState({
      ...this.state,
      encryptedText: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
    });
  }

  getButton = (mode) => {
    return (
      <button
        style={{ marginRight: 3 }}
        onClick={() => this.setState({ mode })}
      >
        {mode} TEST
      </button>
    );
  };

  render() {
    const { mode } = this.state;
    return (
      <>
        <div>{this.TEST_MODE.map(this.getButton)}</div>
        <div style={{ padding: 10 }}>
          {mode === "ENCRYPT" ? (
            <>
              <p>This is Main</p>
              <input
                type="text"
                value={this.state.inputText}
                onChange={this.handleInputChanged}
              />
              <button onClick={this.encryptText}>암호화하기</button>
              <div>
                <p>encrypted: </p>
                <p>{this.state.encryptedText}</p>
              </div>
            </>
          ) : (
            this.TEST_COMPONENT[mode]
          )}
        </div>
      </>
    );
  }
}

const DonutChart = ({ gold, silver, timing = "", loop = false }) => {
  const Circle = ({ zIndex = 0, borderSpace = 0, color = "transparent" }) => {
    return (
      <div
        style={{
          zIndex,
          top: borderSpace,
          bottom: borderSpace,
          left: borderSpace,
          right: borderSpace,
          borderRadius: "50%",
          position: "absolute",
          backgroundColor: color,
        }}
      />
    );
  };

  const AnimationSemiCircle = ({
    zIndex = 0,
    borderSpace = 0,
    color = "transparent",
    percentage = 0,
  }) => {
    const calcPercentage = percentage ? percentage * 1.8 : 0;

    let spin = keyframes`
    0% { transform: rotate(90deg); }
    ${percentage}% { transform: rotate(${90 + calcPercentage}deg); }
    100% { transform: rotate(${90 + calcPercentage}deg); }
`;

    const Test = styled.div`
      z-index: ${zIndex};
      top: ${borderSpace};
      bottom: ${borderSpace};
      left: ${borderSpace};
      right: ${borderSpace};
      border-radius: 50%;
      position: absolute;
      background: conic-gradient(${color} 0% 50%, transparent 50% 100%);
      animation: ${spin} 2s ${timing} ${loop ? "infinite" : "1"} forwards;
    `;
    return <Test />;
  };

  let goldPercentage = 0;
  if (gold) {
    if (!silver) {
      goldPercentage = 100;
    } else {
      goldPercentage = (gold / (gold + silver)) * 100;
    }
  }

  return (
    <div>
      <AspectRatioBox ratio={49}>
        <AspectRatioBox>
          {/* 내부 원 */}
          <Circle zIndex={10} borderSpace={"8%"} color="white" />

          {/* Base */}
          <Circle borderSpace={1} color="purple" />

          {/* 금 */}
          {!!gold && (
            <AnimationSemiCircle
              zIndex={3}
              color="gold"
              percentage={goldPercentage}
            />
          )}

          {/* 은 */}
          {!!silver && (
            <AnimationSemiCircle zIndex={2} color="silver" percentage={100} />
          )}
        </AspectRatioBox>
      </AspectRatioBox>
    </div>
  );
};

// 가로비 / 세로비 * 100
const AspectRatioBox = ({ style = {}, ratio = 100, children }) => {
  return (
    <div
      style={{
        overflow: "hidden",
        paddingTop: ratio + "%",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          ...style,
        }}
      >
        {children}
      </div>
    </div>
  );
};

const DonutTest = () => {
  const ANIMATION_TIMING = [
    {
      NAME: "linear",
      DESC: "일정한 속도로 진행",
    },
    {
      NAME: "ease",
      DESC: "천천히 시작되고 속도가 줄어들면서 끝난다(속도차이 매우 미세)",
    },
    {
      NAME: "ease-in",
      DESC: "천천히 시작 ",
    },
    {
      NAME: "ease-out",
      DESC: "빠르게 시작",
    },
    {
      NAME: "ease-in-out",
      DESC: "빠르게 시작되어 평균속도 유지 (속도차이큼)",
    },
    {
      NAME: "step-start",
      DESC: "시작하자마자 순간적으로 바뀜",
    },
    {
      NAME: "step-end",
      DESC: "시작 유지되다가 끝날때 순간적으로 바뀜",
    },
  ];
  return (
    <>
      {ANIMATION_TIMING.map(({ NAME, DESC }) => {
        return (
          <div style={{ margin: "20px 0 20px" }}>
            {NAME} : {DESC}
            <DonutChart gold={7} silver={3} timing={NAME} loop />
          </div>
        );
      })}
    </>
  );
};
export default Temp;
